import Image from 'next/image';

export const SummerEditionList = () => {
    const sortedLocations: Record<string, string> = LOCATIONS.reduce<Record<string, string>>(
        (acc, location, currentIndex) => {
            const firstLetter = location
                .charAt(0)
                .normalize('NFD') // Normalize to decompose characters with accents
                .replace(/[\u0300-\u036f]/g, '') // Remove accents
                .toUpperCase();

            acc[firstLetter] ??= '';

            acc[firstLetter] += `${location}${currentIndex === LOCATIONS.length - 1 ? '' : ', '}`;

            return acc;
        },
        {},
    );

    return (
        <dl className='dl is-alternate'>
            <dt className='is-3 text'>40 Go utilisables depuis plus de 110 destinations à l&apos;étranger&nbsp;:</dt>
            <dd>
                {Object.entries(sortedLocations).map(([key, location]) => (
                    <>
                        <b>{key}&nbsp;:</b>&nbsp;{location}
                    </>
                ))}
            </dd>
        </dl>
    );
};
export const SummerEditionFlags = () => {
    const path = 'https://bouyguestelecom.fr/assets/media/original/image/CMS/ecommerce/byou';
    return (
        <div style={{ display: 'inline-flex', gap: 4, flexWrap: 'nowrap', verticalAlign: 'bottom' }}>
            <Image
                src={`${path}/switzerland.svg`}
                alt='Suisse'
                width={20}
                height={16}
                style={{ verticalAlign: 'bottom' }}
            />
            <Image src={`${path}/maroc.svg`} alt='Maroc' width={20} height={16} style={{ verticalAlign: 'bottom' }} />
            <Image
                src={`${path}/usa.svg`}
                alt='Etats-Unis'
                width={20}
                height={16}
                style={{ verticalAlign: 'bottom' }}
            />
            <span style={{ marginLeft: 4 }}>...</span>
        </div>
    );
};

const LOCATIONS = [
    'Açores',
    'Afrique du Sud',
    'Aland (Îles)',
    'Alaska',
    'Algérie',
    'Allemagne',
    'Andorre',
    'Angleterre',
    'Arabie Saoudite',
    'Argentine',
    'Australie',
    'Autriche',
    'Baléares (Les)',
    'Belgique',
    'Bénin',
    'Bolivie',
    'Brésil',
    'Bulgarie',
    'Cameroun',
    'Canada',
    'Canaries (Les)',
    'Cap-Vert',
    'Chine',
    'Chypre',
    'Colombie',
    'Comores',
    'Corée du Sud',
    'Corfou',
    "Côte d'Ivoire",
    'Crète',
    'Croatie',
    'Cyclades (Les)',
    'Danemark',
    'Ecosse',
    'Égypte',
    'Espagne',
    'Estonie',
    'Etats-Unis',
    'Féroé (Îles)',
    'Finlande',
    'Gibraltar',
    'Grèce',
    'Guadeloupe',
    'Guatemala',
    'Guernesey',
    'Guyane française',
    'Hawaï',
    'Honduras',
    'Hong Kong',
    'Hongrie',
    'Inde',
    'Irlande',
    'Irlande du Nord',
    'Islande',
    'Israël',
    'Italie',
    'Japon',
    'Jersey',
    'Jordanie',
    'Kazakhstan',
    'Lettonie',
    'Liechtenstein',
    'Lituanie',
    'Luxembourg',
    'Macao',
    'Madagascar',
    'Madère',
    'Malaisie',
    'Mali',
    'Malte',
    'Man (Île de)',
    'Maroc',
    'Martinique',
    'Maurice',
    'Mayotte',
    'Mexique',
    'Monténégro',
    'Norvège',
    'Nouvelle Zélande',
    'Pakistan',
    'Paraguay',
    'Pays de Galles',
    'Pays-Bas',
    'Pérou',
    'Pologne',
    'Porto Rico',
    'Portugal',
    'Qatar',
    'République Dominicaine',
    'République tchèque',
    'Réunion (Île de la)',
    'Rhodes (Île)',
    'Roumanie',
    'Russie',
    'Saint-Barthélemy',
    'Saint-Marin',
    'Saint-Martin',
    'Saint-Pierre-et-Miquelon',
    'Sardaigne',
    'Sénégal',
    'Serbie',
    'Sicile',
    'Singapour',
    'Slovaquie',
    'Slovénie',
    'Suède',
    'Suisse',
    'Thaïlande',
    'Tunisie',
    'Turquie',
    'Vatican',
    'Wight (Île de)',
];
